import * as React from "react";
import {
  ComboBox,
  IComboBoxOption,
  IComboBoxProps,
} from "src/components/ComboBox";
import LIST_OF_BANKS from "src/components/BankSelector/list_of_banks.json";

const listOfBanksAsOptions: IComboBoxOption[] = LIST_OF_BANKS.map((option) => ({
  value: option[0],
  label: option[1],
}));

export const BankSelector = (props: Partial<IComboBoxProps>) => (
  <ComboBox {...props} options={listOfBanksAsOptions} />
);
